import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import classNames from 'classnames'
import VM from 'scratch-vm'

import Box from '../box/box.jsx'
import { STAGE_DISPLAY_SIZES } from '../../lib/layout-constants.js'
import StageHeader from '../../containers/stage-header.jsx'
import Stage from '../../containers/stage.jsx'
import Loader from '../loader/loader.jsx'

import styles from './stage-wrapper.css'
import { connect } from 'react-redux'
import CodeViewer from '../codeViewer/CodeViewer.js'
import Console from '../terminals/Console.js'
import { setCurrentMode } from '../../reducers/script.js'

const StageWrapperComponent = function (props) {
    const {
        isFullScreen,
        menu,
        mobile,
        isRtl,
        isRendererSupported,
        loading,
        stageSize,
        vm,
        hideSimulateScreen,
    } = props
    const params = new URLSearchParams(window.location.search)
    const device = params.get('device') || null
    const version = params.get('version') || null

    const clearConsoleRef = useRef(null)

    const handelConsoleClear = () => {
        if (clearConsoleRef.current) {
            clearConsoleRef.current()
        }
    }

    return (
        <div>
            <Box
                className={classNames(styles.stageWrapper, {
                    [styles.fullScreen]: isFullScreen,
                })}
                dir={isRtl ? 'ltr' : 'ltr'}
            >
                {menu ? (
                    <Box
                        className={styles.stageMenuWrapper}
                        style={
                            // [
                            //     '?pc1.0',
                            //     '?zing0.1',
                            //     '?zing1.0',
                            //     '?zing1.0s3',
                            //     '?klaw',
                            //     '?klaw1.3',
                            //     '?hexapod',
                            //     '?roboki',
                            //     '?hexapod1.0s3',
                            //     '?zing3.0',
                            // ].includes(window.location.search)
                            [
                                'peeCee',
                                'zing',
                                'crawle',
                                'klawb',
                                'roboki',
                                'toki',
                                'poki',
                                'moki',
                            ].includes(device) &&
                            !props.currentMode.isCodingMode
                                ? {
                                      transform: 'translateX(-1270%)',
                                  }
                                : null
                        }
                    >
                        <StageHeader
                            stageSize={stageSize}
                            vm={vm}
                            handelConsoleClear={handelConsoleClear}
                        />
                    </Box>
                ) : null}

                {!hideSimulateScreen && (
                    <Box
                        className={
                            // [
                            //     '?pc1.0',
                            //     '?zing0.1',
                            //     '?zing1.0',
                            //     '?zing1.0s3',
                            //     '?klaw',
                            //     '?klaw1.3',
                            //     '?hexapod',
                            //     '?roboki',
                            //     '?hexapod1.0s3',
                            //     '?zing3.0',
                            // ].includes(window.location.search) &&
                            [
                                'peeCee',
                                'zing',
                                'crawle',
                                'klawb',
                                'roboki',
                                'toki',
                                'poki',
                                'moki',
                            ].includes(device) &&
                            !props.currentMode.isCodingMode
                                ? styles.stageCanvasWrappers
                                : styles.stageCanvasWrapper
                        }
                    >
                        <div id="simstage" style={{ display: 'none' }} />
                        <div className={styles.customStage} style={{}}>
                            <CodeViewer />
                            <Console clearConsoleRef={clearConsoleRef} />
                        </div>
                    </Box>
                )}
                <br></br>
                {loading ? <Loader isFullScreen={isFullScreen} /> : null}
            </Box>
            {!props.currentMode.isCodingMode && (
                <Box
                    className={classNames(styles.stageWrapper, {
                        [styles.fullScreen]: isFullScreen,
                    })}
                    dir={isRtl ? 'ltr' : 'ltr'}
                >
                    <Box
                        className={
                            [
                                'peeCee',
                                'zing',
                                'crawle',
                                'klawb',
                                'roboki',
                                'toki',
                                'poki',
                                'moki',
                            ].includes(device) &&
                            !props.currentMode.isCodingMode
                                ? styles.stageCanvasWrappers
                                : styles.stageCanvasWrapper
                        }
                    >
                        {isRendererSupported ? (
                            <Stage
                                stageSize={stageSize}
                                vm={vm}
                                id={'pyCodeEditor'}
                            />
                        ) : null}
                    </Box>

                    {loading ? <Loader isFullScreen={isFullScreen} /> : null}
                </Box>
            )}
        </div>
    )
}

StageWrapperComponent.propTypes = {
    isFullScreen: PropTypes.bool,
    menu: PropTypes.bool.isRequired,
    isRendererSupported: PropTypes.bool.isRequired,
    isRtl: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    vm: PropTypes.instanceOf(VM).isRequired,
    hideSimulateScreen: PropTypes.bool,
}

const mapStateToProps = (state, ownProps) => {
    const loadingState = state.scratchGui.projectState.loadingState
    const user =
        state.session && state.session.session && state.session.session.user
    return {
        worker: state.scratchGui.worker,
        currentMode: state.scratchGui.script.currentMode,
    }
}

const mapDispatchToProps = (dispatch) => ({
    setCurrentMode: (data) => dispatch(setCurrentMode(data)),
})

// export default StageWrapperComponent
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StageWrapperComponent)
